import React from "react";
import { Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import clsx from "clsx";

const useStyles = makeStyles({
  button: {
    background: "#ff5964",
    color: "white",
    textTransform: "none",
    fontWeight: "bold",
    borderRadius: "2rem",
    "&:hover,&:focus,&:active": {
      background: "#ff5964"
    },
    "&.green": {
      background: "#3ddf76",
      "&:hover,&:focus,&:active": {
        background: "#3ddf76"
      }
    }
  }
});

export default function CustomButton({ children, className, color, ...props }) {
  const classes = useStyles();
  return (
    <Button
      {...props}
      className={clsx(classes.button, className, color)}
      variant="contained"
      disableElevation
    >
      {children}
    </Button>
  );
}
